
/* eslint-disable */
/*
 * @Descripttion: 
 * @version: 
 * @Author: susj
 * @Date: 2020-09-25 15:02:29
 * @LastEditors: susj
 * @LastEditTime: 2020-10-21 16:40:47
 */
import PropTypes from '@/ppt/plugin-common-props'
import { renderWaterMark } from '../../utils/dom-helper'

export default {
  name: 'ppt-background',
  props: {
    bgImage: PropTypes.image({ label: '背景图' }),
    bgColor: PropTypes.color({ label: '背景色', defaultValue: 'rgba(255, 255, 255, 0.2)' }),
    waterMarkText: PropTypes.string({ label: '水印文字', defaultValue: '水印文字' }),
    waterMarkFontSize: PropTypes.number({ label: '水印文字大小(px)', defaultValue: 16 }),
    waterMarkRotate: PropTypes.number({ label: '水印旋转角度', defaultValue: 10 }),
    waterMarkColor: PropTypes.color({ label: '水印文字颜色', defaultValue: 'rgba(184, 184, 184, 0.2)' })
  },
  methods: {
    renderWaterMark() {
      // renderWaterMark({
      //   container: this.$refs.root,
      //   content: this.waterMarkText,
      //   fontSize: this.waterMarkFontSize,
      //   rotate: this.waterMarkRotate,
      //   fillStyle: this.waterMarkColor
      // })
    }
  },
  render() {
    let style = {
      width: '100%',
      height: '100%'
    }
    if (this.bgImage) {
      style = {
        ...style,
        'background-size': 'cover',
        'background-position': '0% 0%',
        'background-repeat': 'none',
        'background-origin': 'content-box',
        'background-image': `url(${process.env.VUE_APP_UPLOAD_RETURN_URL}${this.bgImage})`
      }
    } else {
      style = {
        ...style,
        backgroundColor: this.bgColor
      }
    }

    return (
      // [知识点:CSS] : https://codesandbox.io/s/ziyuansuzindexzaigao-wufafugaifuyuansudexiongdiyuansu-n15rd?file=/index.html
      <div style="width: 100%; height: 100%; overflow: hidden; position: absolute; z-index: 0; opacity: 1;" ref="root">
        <div style={style}></div>
      </div>
    )
  },
  mounted() {
    this.renderWaterMark()

      ;['waterMarkText', 'waterMarkFontSize', 'waterMarkRotate', 'waterMarkColor'].forEach(key => {
        this.$watch(key, this.renderWaterMark)
      })
  }
}
